var React = require('react');

function DownloadDocument (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"b"},React.createElement("rect",{"width":"20","height":"20"}))),React.createElement("g",{"id":"a","clipPath":"url(#b)","key":1},React.createElement("path",{"d":"M17.2,11.6a.8.8,0,0,0-.8.8v3.2a.8.8,0,0,1-.8.8H4.4a.8.8,0,0,1-.8-.8V12.4a.8.8,0,1,0-1.6,0v3.2A2.4,2.4,0,0,0,4.4,18H15.6A2.4,2.4,0,0,0,18,15.6V12.4A.8.8,0,0,0,17.2,11.6ZM9.432,12.968a.8.8,0,0,0,.264.168.752.752,0,0,0,.608,0,.8.8,0,0,0,.264-.168l3.2-3.2a.8.8,0,0,0-1.136-1.136L10.8,10.472V2.8a.8.8,0,1,0-1.6,0v7.672L7.368,8.632A.8.8,0,1,0,6.232,9.768Z","fill":"#00008f"}))]);
}

DownloadDocument.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = DownloadDocument;

DownloadDocument.default = DownloadDocument;
